<div fxLayout="column" fxLayoutAlign="start center">
  <tup-mat-content-wrapper class="main-content" position="first">
      <tup-mat-title-bar title="Basics of Using Telmar APIs"></tup-mat-title-bar>

      <markdown
        [src]="'assets/content/how-to-use-apis.md'"
        (error)="onMarkdownError($event)">
      </markdown>

    </tup-mat-content-wrapper>
</div>

<!--
<div markdown ngPreserveWhitespaces>
  # {{title}}
</div>

<markdown ngPreserveWhitespaces>
```typescript
  const myProp: string = 'value';
```
</markdown>

<div markdown emoji>
  I :heart: markdown
</div>

<div markdown
  [data]="stuff"
  (error)="onMarkdownError($event)"
></div> -->
